import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d56afc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["onMousedown", "onMouseover"]
const _hoisted_3 = {
  key: 0,
  class: "control"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("kbd", null, "Ctrl", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" + ")
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "搜索引擎名称", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "例如：百度", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "搜索引擎图标", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "例如：https://www.baidu.com/favicon.ico", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "搜索引擎链接", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "例如：https://www.baidu.com/s?wd=", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_15 = {
  key: 1,
  class: "hitokoto",
  id: "hitokoto"
}

import { Search, CirclePlus, CircleClose } from "@element-plus/icons-vue";
import { onMounted, ref, watch } from "vue";
import { ElIcon, ElDialog, ElInput, ElButton } from "element-plus";
import axios from "@/utils/http/axios";
import data from "@/data/data";
import notify from "@/utils/notify/notify";
import local from "@/utils/localData/local";
import ClipboardJS from "clipboard";
import hitokoto from "@/utils/hitokoto";

// 选择引擎界面是否打开

export default /*#__PURE__*/_defineComponent({
  __name: 'search',
  setup(__props) {

const soSelect = ref(false);

/**
 * 元素节点
 */
let nodes: any = {};

/**
 * 获取 ref 元素
 */
function setRef(item: any) {
    // 如果元素不存在 或 id 与 refname 都不存在的话
    if (!item || !item.attributes.refname.value) {
        return;
    }

    // 添加到元素节点 优先取 id
    nodes[item.attributes.refname.value] = item;
}

/**
 * setup
 */
hitokoto(); // 获取一言

/**
 * 加载完毕
 */
onMounted(() => {
    /**
     * 一言复制
     */
    // eslint-disable-next-line no-undef
    new ClipboardJS("#hitokoto", {
        text: () => {
            notify("一言已复制", 1);
            return data.hitokoto;
        }
    });
});

watch(
    () => [data.saveData.hitokotoShow, data.saveData.hitokotoIndex],
    () => {
        hitokoto();
    }
);

// Control 是否按下
const controlState = ref(false);

/**
 * 搜索框按键按下
 */
function searchDown(e: any) {
    const keyCode = e.keyCode;

    // console.log("按下", keyCode);

    // Control 按下
    if (!controlState.value) {
        controlState.value = keyCode == 17;
    }

    // Tab 按下
    if (keyCode == 9) {
        e.preventDefault();
        const length = data.saveData.so.length;
        data.saveData.soIndex =
            data.saveData.soIndex == length - 1 ? 0 : data.saveData.soIndex + 1;
    }

    // 上下键检测
    if (data.soBoxlist.length != 0) {
        if (e && keyCode == 38) {
            // 按下上箭头
            // 索引超出判断
            if (data.searchSelectIndex == 0) {
                data.searchSelectIndex = data.soBoxlist.length - 1;
            } else {
                data.searchSelectIndex--;
            }
            // 结果修改
            data.soBoxtext = data.soBoxlist[data.searchSelectIndex].text;
        } else if (e && keyCode == 40) {
            // 按下下箭头
            // 索引超出判断
            if (data.searchSelectIndex == data.soBoxlist.length - 1) {
                data.searchSelectIndex = 0;
            } else {
                data.searchSelectIndex++;
            }
            // 结果修改
            data.soBoxtext = data.soBoxlist[data.searchSelectIndex].text;
        }
    }
}

// 输入框临时内容
const soBoxtextCache = ref("");

// 防抖
let antiShake: any = null;

/**
 * 搜索框键盘放开
 */
function searchGo(e: any) {
    const keyCode = e.keyCode;

    // console.log("松开", keyCode);

    // 是否在 Control 按下的同时按下了数字键
    if (keyCode >= 48 && keyCode <= 57 && controlState.value) {
        const controlDownNum = keyCode - 48;

        // 搜索结果有这个数则跳转
        if (data.soBoxlist.length >= controlDownNum) {
            goHref(data.soBoxlist[controlDownNum - 1].text);
        }
    }
    controlState.value = false;

    if (antiShake) {
        clearTimeout(antiShake);
    }
    antiShake = setTimeout(() => {
        // 是否有内容
        if (!data.soBoxtext) {
            data.soBoxHeight = 0;
            return (data.soBoxlist = []);
        }

        // 无视上下按键
        if ((e && keyCode == 38) || (e && keyCode == 40)) {
            return (soBoxtextCache.value = data.soBoxtext);
        }

        // 回车跳转搜索
        if (keyCode == 13) {
            return enter();
        }

        // 搜索结果选中索引修改
        data.searchSelectIndex = -1;

        // 请求百度获取搜索匹配结果
        axios
            .get("https://api.n0ts.top/baidu", {
                params: {
                    keywords: data.soBoxtext
                }
            })
            .then((res) => {
                // 是否有内容
                if (!data.soBoxtext) {
                    data.soBoxHeight = 0;
                    return (data.soBoxlist = []);
                }
                // 提取搜索结果转为数组
                data.soBoxlist =
                    res.data.result.length > data.saveData.soBoxlistShowNum
                        ? res.data.result.slice(
                              0,
                              data.saveData.soBoxlistShowNum
                          )
                        : res.data.length;

                // 结果框高度计算
                data.soBoxHeight =
                    (data.soBoxlist.length > data.saveData.soBoxlistShowNum
                        ? data.saveData.soBoxlistShowNum
                        : data.soBoxlist.length) * 40;

                // console.log(
                //     "🚀 | file: search.vue | line 260 | .then | data.soBoxlist 搜索结果",
                //     data.soBoxlist
                // );
            })
            .catch(() => {
                data.soBoxHeight = 0;
                return (data.soBoxlist = []);
            });
    }, 100);
}

/**
 * 回车跳转搜索
 */
function enter() {
    if (!data.soBoxtext) {
        return notify("您还没有输入搜索内容呢", 3);
    }
    goHref(data.soBoxtext);
}

/**
 * 跳转搜索
 */
function goHref(item: string) {
    window.open(
        data.saveData.so[data.saveData.soIndex].linkHead +
            encodeURIComponent(item)
    );
}

/**
 * 当搜索框聚焦时关闭搜索引擎选择框
 */
watch(
    () => data.searchBoxFocus,
    () => {
        if (data.searchBoxFocus) {
            // 关闭导航菜单
            // data.openApp = false;
            // 关闭搜索引擎选择框
            soSelect.value = false;
        }
    }
);

/**
 * 添加搜索引擎
 */
function add() {
    // 数据验证
    if (!data.soAdd.name || !data.soAdd.icon || !data.soAdd.linkHead) {
        return notify("请填写全部内容", 2);
    }

    // 添加
    data.saveData.so.push(data.soAdd);
    // 清空数据
    data.soAdd = {
        name: "",
        icon: "",
        linkHead: ""
    };
    // 保存数据
    notify("添加成功", 1);
    local.save();
    // 关闭对话框
    data.soSelectAdd = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "search",
    class: _normalizeClass({
            searchGoTop: _unref(data).openApp,
            searchBlur: !_unref(data).saveData.AeroState
        })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["input", { searchActive: _unref(data).searchBoxFocus }])
    }, [
      _createElementVNode("img", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (soSelect.value = !soSelect.value)),
        src: _unref(data).saveData.so[_unref(data).saveData.soIndex].icon,
        alt: "searchLogo"
      }, null, 8, _hoisted_1),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "搜点什么...",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).soBoxtext) = $event)),
        onFocus: _cache[2] || (_cache[2] = ($event: any) => (_unref(data).searchBoxFocus = true)),
        onBlur: _cache[3] || (_cache[3] = ($event: any) => (_unref(data).searchBoxFocus = false)),
        onKeyup: searchGo,
        onKeydown: searchDown
      }, null, 544), [
        [_vModelText, _unref(data).soBoxtext]
      ]),
      _createVNode(_unref(ElIcon), { onClick: enter }, {
        default: _withCtx(() => [
          _createVNode(_unref(Search))
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["searchResult", {
                searchResultAction: _unref(data).soBoxHeight != 0,
                searchResultClose: !_unref(data).searchBoxFocus
            }]),
      refname: "searchResult",
      ref: setRef,
      style: _normalizeStyle('height:' + _unref(data).soBoxHeight + 'px;')
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).soBoxlist, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onMousedown: ($event: any) => (goHref(item.text)),
          onMouseover: ($event: any) => (_unref(data).searchSelectIndex = index),
          onMouseout: _cache[4] || (_cache[4] = ($event: any) => (_unref(data).searchSelectIndex = -1)),
          class: _normalizeClass({ searchResultActive: _unref(data).searchSelectIndex == index }),
          key: index
        }, [
          _createElementVNode("span", null, _toDisplayString(item.text), 1),
          (controlState.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("kbd", null, _toDisplayString(index + 1), 1)
              ]))
            : _createCommentVNode("", true)
        ], 42, _hoisted_2))
      }), 128))
    ], 6),
    (_unref(data).saveData.so)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["searchChange", { searchChangeActive: soSelect.value }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).saveData.so, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass({
                    searchChangeDivActive: index == _unref(data).saveData.soIndex
                }),
              onClick: ($event: any) => (_unref(data).saveData.soIndex = index)
            }, [
              _createElementVNode("img", {
                src: item.icon,
                alt: item.icon
              }, null, 8, _hoisted_7),
              _createElementVNode("p", null, _toDisplayString(item.name), 1)
            ], 10, _hoisted_6))
          }), 128)),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(data).soSelectAdd = true))
          }, [
            _createVNode(_unref(ElIcon), null, {
              default: _withCtx(() => [
                _createVNode(_unref(CirclePlus))
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (soSelect.value = false))
          }, [
            _createVNode(_unref(ElIcon), null, {
              default: _withCtx(() => [
                _createVNode(_unref(CircleClose))
              ]),
              _: 1
            })
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createVNode(_unref(ElDialog), {
      title: "新增一个搜索引擎",
      modelValue: _unref(data).soSelectAdd,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(data).soSelectAdd) = $event)),
      "append-to-body": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_8,
          _hoisted_9,
          _createVNode(_unref(ElInput), {
            modelValue: _unref(data).soAdd.name,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(data).soAdd.name) = $event)),
            placeholder: "搜索引擎名称"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _hoisted_11,
          _createVNode(_unref(ElInput), {
            modelValue: _unref(data).soAdd.icon,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(data).soAdd.icon) = $event)),
            placeholder: "搜索引擎图标"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _hoisted_13,
          _createVNode(_unref(ElInput), {
            modelValue: _unref(data).soAdd.linkHead,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(data).soAdd.linkHead) = $event)),
            placeholder: "搜索引擎链接"
          }, null, 8, ["modelValue"])
        ]),
        _createVNode(_unref(ElButton), {
          type: "primary",
          onClick: add,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_unref(data).saveData.hitokotoShow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref(data).hitokoto), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})